module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0051_approval_history_device_embedded_information_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "機器・組込情報"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "left",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [(_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("機器登録番号：" + _vm._s(_vm.deviceControlNumber))]) : _vm._e(), _vm._v(" "), (_vm.is_new == false) ? _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("登録日：" + _vm._s(_vm.registrationDate))]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])]), _vm._v(" "), (_vm.is_new == false) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("組込情報")]), _vm._v(" "), _c('sub-table', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("更新履歴")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "to": "/device_embedded_information_pegging2",
      "type": "button"
    }
  }, [_vm._v("新規証書紐付")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    }
  }, [_vm._v("コピー")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-warning btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onLocalSaveDevEmbedded
    }
  }, [_vm._v("登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-warning btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    staticClass: "btn btn-primary btn-xs",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])], 1)], 1), _vm._v(" "), _c('device-embedded-information-confirmation-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        状態：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "value": "使用中"
    }
  }), _vm._v("\n         [承認] 申請No.：\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2efec2e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0051_approval_history_device_embedded_information_detail.vue
// module id = 957
// module chunks = 0